module.exports = __webpack_public_path__ + "img/product_img2.61a797de.png";